<template>
    <div id="table-demo">

    <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
            <vs-row>
                <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
            <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"/>
            <vs-tooltip text="Tambah">
              <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
            </vs-tooltip>
			<vs-tooltip text="Lihat" v-if="btnView === true">
				<vs-button radius size="large" type="border" color="#5d9fc6" icon="print" class="ml-3"  @click="$router.push({name: 'purchase-view', params: {id: data.id, type:'view' }})"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Proses" v-if="btnProcess === true">
				<vs-button radius size="large" type="border" color="primary" icon="send" class="ml-3" @click="openConfirm()"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Diterima" v-if="btnReceive === true">
				<vs-button radius size="large" type="border" color="warning" icon="call_received" class="ml-3" @click="openReceive()"></vs-button>														
			</vs-tooltip>
			<vs-tooltip text="Hapus" v-if="btnDel === true">
				<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="openDelete()"></vs-button>														
			</vs-tooltip>
          </vs-col>
        </vs-row>
      </vx-card>
    </div>      
      
      <vx-card title="List Mutasi Stok" class="sticky-table-content mt-sticky">
        <vs-table stripe max-items="10" class="mb-base" :data="listData" style="text-align:center;" @selected="handleSelected">
            <template slot="thead">
                <vs-th>Tanggal</vs-th>
				<vs-th>Produk</vs-th>				
                <vs-th>Prev Balance</vs-th>
                <vs-th>Qty</vs-th>
                <vs-th>Current Balanace</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].txDate}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].productName}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].startBalance}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].txValue}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].endBalance}}
                    </vs-td>					
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>			
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
import { VueContext } from "vue-context";


export default {
	components: {
		VueContext
	},
	data() {
		return {
			idSelected: null,
			listData: {maxPage:0, data: []},
			loading: true,
			perPage: 50,
			page: 1,
			totalItem: 1,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			this.listData= {maxPage:0, data: []};
			const frm = await stock.listStock(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			}
		},
		async firstLoad() {
			this.find(1);
		},

		async getCityByProvince(first) {
			if (this.model.provinceId) {
				const city = await ref.getCityOfId(
					this.model.provinceId
				);
				if (first) {
					tool.copyValuesToDropDown(
						this.schema.fields,
						"regencyId",
						city.data.data
					);
				} else {
					tool.resetAndCopyValuesToDropDown(
						this.schema.fields,
						"regencyId",
						city.data.data,
						this.model
					);
				}
			}
		},
		async getAllProvince() {
			const prov = await ref.getAllProvince();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"provinceId",
				prov.data.data
			);
		},
		async getBulan() {
			const prov = await ref.getBulan();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"month",
				prov.data.data
			);
		},		
		async getTahun() {
			const prov = await ref.getTahun();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"year",
				prov.data.data
			);
		},
		async getKomoditas() {
			const prov = await ref.getKomoditas();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"commodityId",
				prov.data.data
			);
		},						
		openConfirm(id, status) {
			this.idSelected = id;
			let msg = 'Apakah anda akan me-publish Musim Tanam ini ?';
			if (status == 'PBL') {
				msg = 'Apakah anda akan me-recall Musim Tanam ini ?';
			}
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: msg,
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
			let md = {id: this.idSelected};
			planning.publishMusimTanam(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.firstLoad();
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		}
	},
	computed: {},
	created() {
		this.firstLoad();
	},
	watch: {
		page: function(newValue, oldValue) {
			// here you can do whatever you want
			this.find(newValue);
		}
	}
};
</script>